import Navbar from "../components/global-components/navbar-v4";
import PageHeader from "../components/global-components/page-header";
import LoginSection from "../components/section-components/LoginSection";

const LoginV1 = () => {
    return (
        <div>
            <Navbar CustomClass="ltn__header-transparent gradient-color-2" />
            <PageHeader headertitle="Akun" subheader="Login" />
            <LoginSection />
        </div>
    );
};

export default LoginV1;
